module.exports = __webpack_public_path__ + "static/media/search.7ea95bad.svg";


//////////////////
// WEBPACK FOOTER
// ./src/utils/images/search.svg
// module id = 6325
// module chunks = 1